import { PreferredSizes } from '@/data/types/PreferredSizes';
import { Box, ButtonBase, Typography } from '@mui/material';
import { useMemo } from 'react';

interface Props {
	preferredSizes: PreferredSizes;
	selectedPreferredSizeCategory: string | null;
	selectedPreferredSizes: { label: string; value: string }[];
	gender?: string;
	onClick: (size: string) => () => void;
}

export const BASE_PREFERRED_SIZES_CDN_URL = 'images/preferred_sizes';

export const AccountPreferredSizesCategories: React.FC<Props> = ({
	preferredSizes,
	selectedPreferredSizeCategory,
	selectedPreferredSizes,
	gender,
	onClick,
}) => {
	const filteredPreferredSizes = useMemo(() => {
		let data = Object.keys(preferredSizes);

		if (gender && ['masculino', 'male'].includes(gender.toLowerCase())) {
			data = data.filter((category) => category !== 'TOPS');
		}

		return data;
	}, [preferredSizes, gender]);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				gap: '6px',
			}}
		>
			{filteredPreferredSizes.map((category) => (
				<ButtonBase
					sx={{
						width: '100%',
						flex: 1,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '4px',
						height: '82px',
						border: '1px solid #E8E8E8',
						backgroundColor: selectedPreferredSizeCategory === category ? '#2C2C2C' : '#FFFFFF',
						borderRadius: '4px',
						color: selectedPreferredSizeCategory === category ? '#FFFFFF' : '#2C2C2C',
					}}
					onClick={onClick(category)}
				>
					<Box
						sx={{
							height: '30px',
							width: '30px',
							backgroundColor: selectedPreferredSizeCategory === category ? '#FFFFFF' : '#2C2C2C',
							mask: `url("${BASE_PREFERRED_SIZES_CDN_URL}/${category}.png") no-repeat center / contain`,
							WebkitMask: `url("${BASE_PREFERRED_SIZES_CDN_URL}/${category}.png") no-repeat center / contain`,
						}}
					/>
					<Typography
						sx={{
							fontSize: '15px',
						}}
					>
						{selectedPreferredSizes.find((s) => s.label === category)?.value || '-'}
					</Typography>
				</ButtonBase>
			))}
		</Box>
	);
};
